
import { ajax } from "jquery";
import Loader from "../formbuilder/loader";
import {Select2FormBuilder} from "../formbuilder/select2";
const loader = new Loader();

class CascadingSelects {

    constructor(provinceSelect, districtSelect, communeSelect, citySelect, streetSelect, tercInput, postcodeInput) {
        this.provinceSelect = document.querySelector(provinceSelect);
        this.districtSelect = document.querySelector(districtSelect);
        this.communeSelect = document.querySelector(communeSelect);
        this.citySelect = document.querySelector(citySelect);
        this.streetSelect = document.querySelector(streetSelect);
        this.tercInput = document.querySelector(tercInput);
        this.postcodeInput = document.querySelector(postcodeInput);
        this.apiBaseUrl = '/api/location';


        this.form = this.provinceSelect.closest('form');
        this.init();
    }

    init() {
        this.provinceSelect.addEventListener('change', () => this.updateDistricts());
        this.districtSelect.addEventListener('change', () => this.updateCommunes());
        this.communeSelect.addEventListener('change', () => this.updateCities());
        this.citySelect.addEventListener('change', () => { this.setTerc(), this.setPostcodes(this.citySelect, true), this.updateStreet() });
        this.streetSelect.addEventListener('change', () => {this.setPostcodes(this.streetSelect)});
        this.streetSelect.select2el = new Select2FormBuilder(this.streetSelect, true);
        this.streetSelect.select2el.attachTyping();

        if(this.provinceSelect != ''){
            this.updateDistricts();
        }
    }

    async updateDistricts() {
        this.clearOptions(this.districtSelect);
        this.clearOptions(this.communeSelect);
        this.clearOptions(this.citySelect);
        this.clearOptions(this.streetSelect);
        this.clearOptions(this.postcodeInput);
        this.tercInput.value = '';

        let province = this.provinceSelect.value;
        this.districtSelect[0].text = 'Pobieranie listy powiatów ...';
        if (province) {
            let districts = await this.fetchData(`/district/${province}`);
            if (districts) {
                this.populateOptions(this.districtSelect, districts);
            }
        }
    }

    async updateCommunes() {
        this.clearOptions(this.communeSelect);
        this.clearOptions(this.citySelect);
        this.clearOptions(this.streetSelect);
        this.clearOptions(this.postcodeInput);
        this.tercInput.value = '';


        this.communeSelect[0].text = 'Pobieranie listy gmin ...';
        let district = this.districtSelect[this.districtSelect.selectedIndex].dataset.gaid;

        if (district) {
            let communes = await this.fetchData(`/commune/${district}`);

            if (communes) {
                this.populateOptions(this.communeSelect, communes);
            }

        }
    }

    async updateCities() {
        this.clearOptions(this.citySelect);
        this.clearOptions(this.streetSelect);
        this.clearOptions(this.postcodeInput);

        let communeGaid = this.communeSelect[this.communeSelect.selectedIndex].dataset.gaid;
        this.citySelect[0].text = 'Pobieranie listy miejscowości ...';
        if (communeGaid) {
            var communes = communeGaid.split(',');
            const promises = communes.map(commune => this.fetchData(`/city/${commune}`));
            const results = await Promise.all(promises);
            let cities = results.flat();

            if (cities) {
                cities.sort((a, b) => a.name.localeCompare(b.name));
                this.populateOptions(this.citySelect, cities, true);
            }

        }
    }

    async updateStreet() {
        this.streetSelect.select2el.changePlaceholder('Pobieranie listy ulic ...');

        this.clearOptions(this.streetSelect);

        let city = this.citySelect[this.citySelect.selectedIndex].dataset.gaid;

        if(city){
            let streets = await this.fetchData(`/street/${city}`);
            if(streets){
                this.streetSelect.select2el.changePlaceholder('Wybierz lub wyszukaj poprzedzając nazwę jednym z skrótów: ul. , pl., os., al.');
                this.populateOptions(this.streetSelect, streets);
                this.streetSelect.select2el.el.enpoint = `/street/${city}`;
                this.streetSelect.select2el.el.removeEventListener('select2:noResultsTrigger',this.updateStreetSelect2);
                this.streetSelect.select2el.el.addEventListener('select2:noResultsTrigger',this.updateStreetSelect2.bind(this));

            }
            else {
                console.log('BRAK ULIC');
                this.populateOptions(this.streetSelect, [{'name': 'Brak ulic'}]);
                this.streetSelect.value = 'Brak ulic';
            }
        }
    }
    setTerc() {
        this.tercInput.value = this.citySelect[this.citySelect.selectedIndex].dataset.terc;
    }
    setPostcodes(selectElement, setNew = false) {
        var postCode = selectElement[selectElement.selectedIndex].dataset.postcode;
        if(postCode)
        {
            var postCodes = postCode.split(',');

            if(setNew)
            {
                this.clearOptions(this.postcodeInput);
                this.populateOptions(this.postcodeInput, postCodes);
            }
            this.postcodeInput.value = postCodes[0];
            this.postcodeInput.dispatchEvent( new Event('change', { bubbles: true }));

        }

    }

    populateOptions(selectElement, optionsData, addTercData = false) {
        selectElement[0].text='--Wybierz--';
        optionsData.forEach(value => {

            if(!selectElement.querySelector('option[value=\''+value.name+'\']')) // do not add if street arleady exist
            {
                let option = document.createElement('option');
                option.value = value.name ?? value;
                option.textContent = value.name ?? value;
                option.dataset.gaid = value.gaid ?? '';
                if (addTercData) {
                    option.dataset.terc = value.terccode[0].value ?? '';
                }
    
                if(value.postcode)
                {
                    option.dataset.postcode = value.postcode;
                }
    
                selectElement.appendChild(option);
            }
            else if(value.gaid && !selectElement.querySelector('[data-gaid=\''+value.gaid+'\']')) // if have 2 commune with the same name
            {
                selectElement.querySelector('option[value=\''+value.name+'\']').dataset.gaid += ","+value.gaid;
            }

        });


        if(selectElement.length == 2)//if only exist one location in list (--wybierz--, [location]), set already next select. for example Powiat: Poznań, Gmina: Poznań, Miasto: Poznań
        {
            selectElement.value = selectElement[1].value;
            selectElement.dispatchEvent(new Event('change'));
        }

        selectElement.removeAttribute("disabled");
    }

    clearOptions(selectElement) {
        selectElement.innerHTML = '<option value=""></option>';
        selectElement.disabled = 'true';
    }

    async fetchData(endpoint) {
        // loader.addLoader(this.form);
        try {
            let response = await fetch(this.apiBaseUrl + endpoint);
            if (!response.ok) throw new Error("Błąd pobierania danych");
            return await response.json();
        } catch (error) {
            console.error("Błąd:", error);
            return false;
        }
        finally{
            // loader.removeLoader();
        }
    }

    async updateStreetSelect2(e){

        e.target.select2el.customsearching();
        let addtionalStreet = await this.fetchData(e.target.enpoint+'/'+e.detail.term);
            if(addtionalStreet)
            {
                this.populateOptions(this.streetSelect, addtionalStreet);
                e.target.select2el.restartSelect2(e.detail.term); //re-open dropdown select and filter again 

            }
            else
            {
                e.target.select2el.endsearching();
            }

    }
}


document.querySelectorAll('[data-location-select]').forEach(element => {
    let inputs = element.getAttribute('data-location-select');
    let formbuilderId = element.closest('form').name;
    var [districtSelect, communeSelect,citySelect, streetSelect, tercInput, postcodeInput] = inputs.split(",").map(function(e){return "[name='"+formbuilderId+"["+e+"]']"});

    const LocationBAS = new CascadingSelects("[name='"+element.name+"']", districtSelect, communeSelect, citySelect, streetSelect, tercInput, postcodeInput);

});
